








import { Component, Mixins, PropSync } from 'vue-property-decorator'
import BaseVue from '@/mixins/BaseVue'

@Component
export default class ListOptionFilter extends Mixins(BaseVue) {
  @PropSync('option', { type: Number })
  optionSync!: number
}
